<div class="modal-backdrop" *ngIf="isOpen">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <button class="close-button" (click)="closeModal()"
    aria-label="Cerrar">&times;</button>
    <ng-container *ngIf="contentComponent">
      <ng-container
        *ngComponentOutlet="
          contentComponent;
          injector: contentInjector
        "></ng-container>
    </ng-container>
  </div>
</div>
